<div class="InboxManagement container">
  <div class="InboxManagement__header">
    <h4 class="InboxManagement__title">Configure Inbox Management</h4>
  </div>
  <div
    *ngIf="componentReady"
    class="InboxManagement__body"
    [formGroup]="formGroup">
    <div class="row">
      <mat-accordion>
        <mat-expansion-panel
          #inboxCleaningPanel
          [disabled]="!enableInboxCleaningPanel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-checkbox
                [checked]="enableInboxCleaningPanel"
                (change)="toggleCleaningPanel()"
                >Inbox cleaning tool</mat-checkbox
              >
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col col-6">
              <p class="InboxManagement__body__label">
                Days after (number of days to wait before executing the
                scheduled action)
              </p>
            </div>
            <div class="col col-6">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  placeholder="Days after"
                  formControlName="inbox_delay" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col col-6">
              <p class="InboxManagement__body__label no-margin">
                Action to perform
              </p>
            </div>
            <div class="col col-6">
              <mat-radio-group
                formControlName="inbox_type"
                (change)="onInboxTypeChange($event)">
                <mat-radio-button
                  class="InboxManagement__body__radio"
                  value="cycle"
                  >Cycle</mat-radio-button
                >
                <mat-radio-button
                  class="InboxManagement__body__radio"
                  value="campaign"
                  >Campaign</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
          <div *ngIf="showInboxCapaignConfig">
            <div class="row">
              <div class="col col-6">
                <p class="InboxManagement__body__label">
                  Move contact to selected campaign
                </p>
              </div>
              <div class="col col-6">
                <app-select
                  [items]="getCampaignsSelectItems()"
                  label="Campaign"
                  formControlName="inbox_campaign"
                  (selection)="onCampaignSelection($event)"></app-select>
              </div>
            </div>
            <div *ngIf="inboxSelectedCampaignId" class="row">
              <div class="col col-6">
                <p class="InboxManagement__body__label">
                  Move contact to selected contact group
                </p>
              </div>
              <div class="col col-6">
                <app-select
                  [items]="getContactGroupsSelectItems()"
                  label="Contact group"
                  formControlName="inbox_group"></app-select>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <mat-divider></mat-divider>
    <div class="row">
      <mat-accordion>
        <mat-expansion-panel #meetingPanel [disabled]="!enableMeetingPanel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-checkbox
                [checked]="enableMeetingPanel"
                (change)="toggleMeetingPanel()"
                >Meeting, Order, Quote moving tool</mat-checkbox
              >
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col col-6">
              <p class="InboxManagement__body__label">
                Days after (number of days to wait before executing the
                scheduled action)
              </p>
            </div>
            <div class="col col-6">
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  placeholder="Days after"
                  formControlName="meeting_delay" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col col-6">
              <p class="InboxManagement__body__label">
                Move opportunity to selected campaign
              </p>
            </div>
            <div class="col col-6">
              <app-select
                [items]="getCampaignsSelectItems()"
                label="Campaign"
                formControlName="meeting_campaign"
                (selection)="onCampaignSelection($event, true)"></app-select>
            </div>
          </div>
          <div *ngIf="meetingSelectedCampaignId" class="row">
            <div class="col col-6">
              <p class="InboxManagement__body__label">
                Move opportunity to selected contact group
              </p>
            </div>
            <div class="col col-6">
              <app-select
                [items]="getContactGroupsSelectItems(true)"
                label="Contact group"
                formControlName="meeting_group"></app-select>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="InboxManagement__footer">
    <app-button
      *ngIf="turnOffButtonProperties"
      [size]="turnOffButtonProperties.size"
      [color]="turnOffButtonProperties.color"
      [text]="turnOffButtonProperties.text"
      [Click]="turnOffButtonProperties.onClick"></app-button>
    <app-button
      [size]="turnOnButtonProperties.size"
      [color]="turnOnButtonProperties.color"
      [text]="turnOnButtonProperties.text"
      [Click]="turnOnButtonProperties.onClick"></app-button>
  </div>
</div>
